import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";

import React from "react";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import { useIsDev } from "@repo/lib-web-common";

export const Route = createRootRouteWithContext<{
  user: { loading: boolean; id: undefined | string };
  params?: Record<string, string>;
}>()({
  component: Root,
});

function Root(): React.JSX.Element {
  React.useEffect(() => {
    console.log("root: ", window.location.href);
  }, []);

  const isDev = useIsDev();
  return (
    <>
      <Outlet />
      {isDev && <TanStackRouterDevtools position="bottom-right" />}
    </>
  );
}
